// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.vrmodel.RentalManagerUserPropertyVrModelV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyVrModelV2WebApiHandler_associateListing,
  RentalManagerUserPropertyVrModelV2WebApiHandler_associateModel,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  UserPropertyVrModelAssociateListingResponseV2WebDto,
  UserPropertyVrModelAssociateListingV2RequestDto,
  UserPropertyVrModelAssociateModelResponseV2WebDto,
  UserPropertyVrModelAssociateModelV2RequestDto,
} from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserPropertyVrModelV2WebApiHandler_associateListing_Args {
  postData: UserPropertyVrModelAssociateListingV2RequestDto;
}

export type RentalManagerUserPropertyVrModelV2WebApiHandler_associateListing_Options = UseMutationOptions<
  UserPropertyVrModelAssociateListingResponseV2WebDto,
  unknown,
  RentalManagerUserPropertyVrModelV2WebApiHandler_associateListing_Args
>;

/**
 * Associate / Disassociate a vrModel to listing
 */
export const useRentalManagerUserPropertyVrModelV2WebApiHandler_associateListing = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyVrModelV2WebApiHandler_associateListing_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyVrModelV2WebApiHandler_associateListing_Args) =>
      RentalManagerUserPropertyVrModelV2WebApiHandler_associateListing(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyVrModelV2WebApiHandler_associateModel_Args {
  postData: UserPropertyVrModelAssociateModelV2RequestDto;
}

export type RentalManagerUserPropertyVrModelV2WebApiHandler_associateModel_Options = UseMutationOptions<
  UserPropertyVrModelAssociateModelResponseV2WebDto,
  unknown,
  RentalManagerUserPropertyVrModelV2WebApiHandler_associateModel_Args
>;

/**
 * Associate / Disassociate a vrModel to a floor plan or unit
 */
export const useRentalManagerUserPropertyVrModelV2WebApiHandler_associateModel = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyVrModelV2WebApiHandler_associateModel_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyVrModelV2WebApiHandler_associateModel_Args) =>
      RentalManagerUserPropertyVrModelV2WebApiHandler_associateModel(args.postData, httpClient),
  });
};
